module.exports = __webpack_public_path__ + "media/images/front/products/extra_standard/product_1-4f85347d0fc15d3d96aa5d976164eec9.jpg";